import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import DefaultCard from '../../../components/DefaultCard';
import IconButton from '../../../components/IconButton/IconButton';
import Link from '../../../components/Link';
import ModalHeader from '../../../components/ModalHeader';
import { RadioGroup } from '../../../components/Radio';
import SelectableCard from '../../../components/SelectableCard';
import { EnrollmentStore } from '../../../providers/enrollment';
import { getAllHospitalIndemnity } from '../../../services/enrollment';

export type customHospitalIndemnityModalProps = {
  showHospitalIndemnityModal: boolean;
  handleCloseHospitalIndemnityModal: () => void;
};

const HospitalIndemnityModal = ({
  showHospitalIndemnityModal,
  handleCloseHospitalIndemnityModal,
}: customHospitalIndemnityModalProps) => {
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [hospitalIndemnityData, setHospitalIndemnityData] = React.useState<any>(
    {}
  );
  const { activeHealthBenefits, updateCost, updatePlanName } =
    useContext(EnrollmentStore);

  const [radioButtonValue, setRadioButtonValue] = React.useState<
    string | number
  >(9);

  const [tellMeMore, setTellMeMore] = useState(false);

  useEffect(() => {
    const data = getAllHospitalIndemnity();

    if (data) {
      setHospitalIndemnityData(data);
    }
  }, [hospitalIndemnityData]);

  useEffect(() => {
    const currentBenefit = activeHealthBenefits.find(
      (benefit: any) => benefit.type === 'hospital-indemnity'
    );
    const index = hospitalIndemnityData.plans?.findIndex(
      (plan: any) => plan.id === currentBenefit?.plan?.id
    );
    setRadioButtonValue(index);
  }, [activeHealthBenefits, hospitalIndemnityData]);

  const handleRadioButtonValue = (e: string | number) => {
    setRadioButtonValue(e);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const handleTellMeMore = () => {
    setTellMeMore((prev) => !prev);
  };

  return (
    <>
      {hospitalIndemnityData ? (
        <Modal
          show={showHospitalIndemnityModal}
          onHide={handleCloseHospitalIndemnityModal}
          dialogClassName="modal-xl"
          className="custom-health-savings-modal"
        >
          <ModalHeader
            rightButton={
              <div onClick={toggleDetails} className={'icon-button-wrapper'}>
                <IconButton
                  variant="icon-default"
                  icon={light('circle-exclamation')}
                  extLabel="Benefit Info"
                />
              </div>
            }
            leftIcon={light('hospitals')}
            leftIconVariant="icon-default"
          >
            <h4 className="text-sm-20-lg-32">
              {hospitalIndemnityData['generic']
                ? hospitalIndemnityData['generic']['title']
                : ''}
            </h4>
          </ModalHeader>
          <ModalBody>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="d-flex justify-content-center">
                <DefaultCard
                  closeButton={
                    <Link 
                      className='pt-0' 
                      isAlignAtEnd 
                      isWhiteIcon 
                      rightIcon={light('close')}
                      onClick={toggleDetails}
                    />                      
                  }
                  variant="blue-motif"
                  leftHeading={
                    hospitalIndemnityData['generic']
                      ? hospitalIndemnityData['generic']['info']['title']
                      : ''
                  }
                  leftSubheading={
                    <Container className={'px-0 d-flex flex-column'}>
                      {hospitalIndemnityData['generic'] ? (
                        <>
                          <span>
                            {
                              hospitalIndemnityData['generic']['info'][
                                'description'
                              ]
                            }
                          </span>

                          {tellMeMore && (
                            <Container className={'px-0 d-flex flex-column'}>
                              <span className={'mt-1'}>
                                {
                                  hospitalIndemnityData['generic']['info'][
                                    'additionalDescription'
                                  ].split(' // ')[0]
                                }
                              </span>
                              <span className={'mt-1'}>
                                {
                                  hospitalIndemnityData['generic']['info'][
                                    'additionalDescription'
                                  ].split(' // ')[1]
                                }
                              </span>
                            </Container>
                          )}
                        </>
                      ) : (
                        ''
                      )}
                    </Container>
                  }
                  button={
                    <Button
                      onClick={handleTellMeMore}
                      variant="primary-shadow"
                      size="sm"
                    >
                      {tellMeMore ? 'Tell me less' : 'Tell me more'}
                    </Button>
                  }
                  className={'mb-12'}
                />
              </div>
            </Row>
            <Container className="p-0">
              <Row className="mb-7 mb-lg-12">
                <h5 className="text-sm-14-lg-24">
                  What option would you like?
                </h5>
              </Row>
              <Row>
                <RadioGroup
                  name={'pricing-test1'}
                  value={radioButtonValue}
                  onChange={handleRadioButtonValue}
                >
                  <div>
                    {hospitalIndemnityData['plans']
                      ? hospitalIndemnityData['plans'].map(
                          (
                            plan: {
                              title: string;
                              cost: any;
                              coverage: number;
                            },
                            i: any
                          ) => (
                            <SelectableCard
                              title={plan.title}
                              prePaydPeriod={plan.cost}
                              radioButtonValue={i}
                              selected={radioButtonValue === i}
                              disabled={
                                i === hospitalIndemnityData['plans'].length - 1
                              }
                              key={i}
                            />
                          )
                        )
                      : ''}
                  </div>
                </RadioGroup>
              </Row>
            </Container>
          </ModalBody>
          <Modal.Footer className="pt-7">
            <Button
              onMouseDown={handleCloseHospitalIndemnityModal}
              className="text-nowrap mt-7 mt-lg-0"
              variant="primary-outline"
            >
              Cancel
            </Button>
            <Button
              onMouseDown={() => {
                updateCost(
                  'hospital-indemnity',
                  hospitalIndemnityData.plans[radioButtonValue]
                );
                updatePlanName(
                  'hospital-indemnity',
                  hospitalIndemnityData.plans[radioButtonValue]
                );
                handleCloseHospitalIndemnityModal();
              }}
              className="text-nowrap"
              variant="primary"
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        'NO DATA'
      )}
    </>
  );
};

export default HospitalIndemnityModal;
